import {ChangeDetectorRef, Directive, ElementRef, Self} from '@angular/core';
import {NgModel} from '@angular/forms';
import {GridFilterDirective} from './grid-filter.directive';
import {Dropdown} from 'primeng/primeng';
import {ElementState} from '../../../services/element-state';
import {ChangeDetectorRefHelper} from '../../../../helpers/change-detector-ref.helper';

@Directive({
  selector: '[gridFilterDropdown]',
  host: {
    '(input)': 'onInput($event)',
    '(onChange)': 'onChange($event)',
    '(onSelect)': 'onSelect($event)',
    '(onUnselect)': 'onSelect($event)'
  },
  providers: [NgModel]
})
export class GridFilterDropdownDirective extends GridFilterDirective {

  private readonly dropdown: Dropdown = null;
  public constructor(
    protected elementRef: ElementRef,
    protected ngModel: NgModel,
    public cdr: ChangeDetectorRef,
    @Self() dropdown: Dropdown
  ) {
    super(elementRef, ngModel, cdr);

    if (dropdown) {
      this.dropdown = dropdown;
    }
  }

  public setValue(componentState: ElementState): void {
    super.setValue(componentState);

    const filterState = this.getFilter(componentState);

    if (this.dropdown && filterState && filterState.value && filterState.labelValue) {
      const valueInOptionsIndex = (this.dropdown.optionsToDisplay || []).findIndex((aOption) => aOption.value === filterState.value);

      if (valueInOptionsIndex === -1) {
        this.dropdown.optionsToDisplay = [{
          value: filterState.value,
          label: filterState.labelValue
        }];
      }

      this.dropdown.updateSelectedOption(valueInOptionsIndex === -1 ? {
        value: filterState.value,
        label: filterState.labelValue
      } : this.dropdown.optionsToDisplay[valueInOptionsIndex].value);

      ChangeDetectorRefHelper.detectChanges(this);
    }
  }
}
